

const productsMenu = {
  icon: "md-cube",
  name: "products",
  title: "商品管理",
  children: [
    {
      title: "商品列表",
      route: "/products/products/list"
    },
    {
      title: "商品分类",
      route: "/products/products/categories"
    }
  ]
};

const platformReportsMenu = {
  icon: "logo-bitcoin",
  name: "reports",
  title: "财务管理",
  children: [
    {
      title: "订单列表",
      route: "/reports/orders/list"
    },
    {
      title: "分销员佣金",
      route: "/reports/commissions/list"
    },
    {
      title: "分销员提现",
      route: "/reports/withdraws/list/userType/Distributor"
    },
    {
      title: "校区收入",
      route: "/reports/incomes/list"
    },
    {
      title: "校区提现",
      route: "/reports/withdraws/list/userType/School"
    },
    {
      title: "平台收入",
      route: "/reports/all-incomes/list"
    },
    {
      title: "积分",
      route: "/reports/points/list"
    }
  ]
};

const schoolReportsMenu = {
  icon: "logo-bitcoin",
  name: "reports",
  title: "财务管理",
  children: [
    {
      title: "订单列表",
      route: "/reports/orders/list"
    },
    {
      title: "校区收入",
      route: "/reports/incomes/list"
    },
    {
      title: "校区提现",
      route: "/reports/withdraws/list/userType/School"
    },
    {
      title: "积分",
      route: "/reports/points/list"
    }
  ]
};

const marketingMenu = {
  icon: "ios-browsers",
  name: "marketing",
  title: "营销管理",
  children: [
    {
      title: "优惠券",
      route: "/marketing/coupons/list"
    }
  ]
};

const articlesMenu = {
  icon: "md-document",
  name: "articles",
  title: "图文管理",
  children: [
    {
      title: "图文列表",
      route: "/articles/articles/list"
    },
    {
      title: "图文分类",
      route: "/articles/articles/categories"
    }
  ]
};

const usersMenu = {
  icon: "md-person",
  name: "users",
  title: "用户管理",
  children: [
    {
      title: "分销员申请",
      route: "/users/distributor-applications/list"
    },
    {
      title: "微信用户",
      route: "/users/schoolWxUsers/list"
    }
  ]
};

const classesMenu = {
  icon: "md-cube",
  name: "classes",
  title: "课消管理",
  children: [
    {
      title: "教师列表",
      route: "/classes/teachers/list"
    },
    {
      title: "家长列表",
      route: "/classes/parents/list"
    },
    {
      title: "学生列表",
      route: "/classes/students/list"
    },
    {
      title: "班级列表",
      route: "/classes/classes/list"
    },
    {
      title: "课消统计",
      route: "/classes/classes/statistics"
    },
    {
      title: "学员点评",
      route: "/classes/student-comments/list"
    }
  ]
};

export default schoolId => {
  const platformMenu = {
    icon: "md-school",
    name: "schools",
    title: "校区管理",
    children: [
      {
        title: "校区列表",
        route: "/schools/schools/list"
      },
      {
        title: "全局设置",
        route: "/schools/settings/list/form/1"
      },
      {
        title: "主校区设置",
        route: "/schools/schools/list/form/1"
      },
      {
        title: "画展表单",
        route: "/schools/form/list?type=01"
      }
    ]
  };

  const schoolsMenu = {
    icon: "md-school",
    name: "schools",
    title: "校区设置",
    children: [
      {
        title: "校区设置",
        route: `/schools/schools/list/form/${schoolId}`
      }
    ]
  };


  const pttj_zx = {
    title: "品牌推荐",
    route: "/dresses/brands/list"
  };
  const pttj_fx = {
    icon: "md-school",
    title: "品牌推荐",
    name: 'brands',
    children: [
      {
        title: "品牌推荐",
        route: "/dresses/brands/list"
      },
      {
        title: "艺术家列表",
        route: "/dresses/brands/artist/list"
      },
      {
        title: "作品栏目",
        route: "/dresses/brands/arts/list"
      },
      {
        title: "作品展栏目",
        route: "/dresses/brands/artshow/list"
      },
      {
        title: "活动栏目",
        route: "/dresses/brands/activity/list"
      },
      {
        title: "留言",
        route: "/dresses/brands/artremark/list"
      },
      {
        title: "画展表单",
        route: "/dresses/brands/form/list?type=02"
      }
    ]
  };

  let pttj = schoolId === 1 ? pttj_zx : pttj_fx;


  const dressesMenu = {
    icon: "md-bowtie",
    name: "dresses",
    title: "首页管理",
    children: [
      {
        title: "首页装修",
        route: "/dresses/dresses/home"
      },
      {
        title: "轮播广告",
        route: "/dresses/ads/list"
      },
      {
        title: "校区公告",
        route: "/dresses/notices/list"
      },
      {
        title: "功能入口",
        route: "/dresses/entries/list"
      },
      {
        title: "快捷入口",
        route: "/dresses/shortcuts/list"
      },
      pttj,
      {
        title: "外链商品",
        route: "/dresses/outer-products/list"
      },
      {
        title: "投票",
        route: "/dresses/votes/list"
      }
    ]
  };

  return schoolId === 1
    ? [
        platformMenu,
        dressesMenu,
        productsMenu,
        platformReportsMenu,
        marketingMenu,
        articlesMenu,
        classesMenu,
        usersMenu
      ]
    : [
        schoolsMenu,
        dressesMenu,
        productsMenu,
        schoolReportsMenu,
        marketingMenu,
        articlesMenu,
        classesMenu,
        usersMenu
      ];
};
